/**
 * ALD-style mobile sticky bottom bar for the product page.
 *
 * At widths under 990px, this MOVES (not clones) the real title, price,
 * variant picker, and the Add to Cart / Notify When Back in Stock stack
 * into a fixed bar at the bottom of the screen. Because the actual DOM
 * nodes are relocated rather than duplicated, all existing
 * functionality (variant selection, cart submission, notify signup,
 * error handling, and the crossfade between Add to Cart and Notify)
 * keeps working exactly as it did before — there's only ever one live
 * copy of each control.
 *
 * The Add to Cart button and Notify button are moved together as a
 * single ".product-form__cta-stack" unit (rather than individually) so
 * the crossfade transition between them keeps working identically in
 * the sticky bar as it does in the normal page flow.
 *
 * If the viewport crosses back over the 990px breakpoint (e.g. resizing
 * a browser window, or a foldable/tablet rotating), everything is moved
 * back to its original position in the normal page flow.
 */
(function () {
  function setupStickyBar(root) {
    var sectionId = root.getAttribute('data-section-id');
    var infoRoot = document.getElementById('ProductInfo-' + sectionId);
    if (!infoRoot) return;

    var titleEl = infoRoot.querySelector('.product__title');
    var priceEl = document.getElementById('price-' + sectionId);
    var variantEl = document.getElementById('variant-selects-' + sectionId);
    var ctaStackEl = infoRoot.querySelector('.product-form__cta-stack');

    // Title, price, and the CTA stack (Add to Cart / Notify) are
    // required. Variant picker is optional (products with only a
    // default variant won't render one at all).
    if (!titleEl || !priceEl || !ctaStackEl) return;

    var tracked = [titleEl, priceEl, variantEl, ctaStackEl].filter(Boolean);

    // Mark each element's original position with a comment node so we
    // can put it back exactly where it came from later.
    var anchors = tracked.map(function (el) {
      var anchor = document.createComment('product-sticky-bar-anchor');
      el.parentNode.insertBefore(anchor, el);
      return { el: el, anchor: anchor };
    });

    var summary = document.createElement('div');
    summary.className = 'product-sticky-bar__summary';

    var controls = document.createElement('div');
    controls.className = 'product-sticky-bar__controls';

    root.appendChild(summary);
    root.appendChild(controls);

    // Move the bar itself to be a direct child of <body>. This avoids a
    // subtle bug: if any ancestor in the page has a CSS transform
    // applied (Dawn's scroll-reveal animations do this), position:fixed
    // descendants get positioned relative to that ancestor instead of
    // the viewport. Being a direct child of <body> sidesteps that.
    document.body.appendChild(root);

    var moved = false;

    function moveIntoBar() {
      if (moved) return;
      summary.appendChild(titleEl);
      summary.appendChild(priceEl);
      if (variantEl) controls.appendChild(variantEl);
      controls.appendChild(ctaStackEl);
      moved = true;
    }

    function restoreToPage() {
      if (!moved) return;
      anchors.forEach(function (item) {
        item.anchor.parentNode.insertBefore(item.el, item.anchor.nextSibling);
      });
      moved = false;
    }

    var mobileQuery = window.matchMedia('(max-width: 989px)');

    function applyForViewport(event) {
      var isMobile = event.matches;
      if (isMobile) {
        moveIntoBar();
        root.classList.add('product-sticky-bar--active');
        document.body.classList.add('has-product-sticky-bar');
      } else {
        restoreToPage();
        root.classList.remove('product-sticky-bar--active');
        document.body.classList.remove('has-product-sticky-bar');
      }
    }

    applyForViewport(mobileQuery);

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', applyForViewport);
    } else if (mobileQuery.addListener) {
      // Safari < 14 fallback
      mobileQuery.addListener(applyForViewport);
    }
  }

  function init() {
    document.querySelectorAll('[data-product-sticky-bar]').forEach(setupStickyBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();